import { render, staticRenderFns } from "./Trackarchives.vue?vue&type=template&id=d6f612da&style=height%3A100%25"
import script from "./Trackarchives.vue?vue&type=script&lang=js"
export * from "./Trackarchives.vue?vue&type=script&lang=js"
import style0 from "./Trackarchives.vue?vue&type=style&index=0&id=d6f612da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports